import React from "react";
const PostItem = (
    {
      post ={
        "avatar": "https://pbs.twimg.com/profile_images/1442634650703237120/mXIcYtIs_400x400.jpg",
        "handle": "elonmusk", "name": "Elon Musk",
        "time": "23h",
        "content": "Amazing show about <span class='link-primary'>@Inspiration4x</span> mission!",
        "image": "https://pbs.twimg.com/card_img/1446647628930838528/BsMV4oVF?format=jpg&name=small",
        "icon":"fas fa-link wd-gray",
        "url": "https://www.netflix.com/title/81441273",
        "shorturl": "netflix.com",
        "title": "Countdown: Inspiration4 Mission to Space | Netflix Offical Site",
        "summary": "From training to launch to landing, this all-access docuseries rides along with the Inspiration4 crew on the first all-civilian orbital space ...",
        "reply": "4.2k",
        "retweet": "3.5k",
        "like": "37.5k"
      }
    }) => {
  return(
       <div className={`container border-secondary border-bottom mt-2`}>
         <div className={`row`}>
          <div className={`col-2 position-absolute`}>
            <img className={`rounded-circle`} alt={'avatar'} src={post.avatar} width="50"/>
          </div>
          <div className={`col-auto`}>
            <div className={`container ps-5 mt-2`}>
              <p className={`lh-1 wd-black wd-font-15 wd-bold text-white ps-2`}>{post.name}<i className={`fas fa-check-circle`}></i><span className={`wd-gray`}> @{post.handle} - {post.time}</span></p>
              <h5 className={`lh-1 wd-lightgray wd-font-13 text-white ps-2`}>{post.content}</h5>
              <div className={`card mt-3 text-white bg-dark border-secondary rounded-corners-all-around`} >
                <img
                  src={post.image}
                  alt={'Post'}
                  className={`card-img-top`}/>
              </div>
            </div>
          </div>
        </div>
        <div className={`container ps-5 mt-2 mb-2`}>
          <div className={`row ps-10`}>
            <div className={`col wd-gray wd-font-15`}>
              <i className={`far fa-comment`}> {post.reply}</i>
            </div>
            <div className={`col wd-gray wd-font-15`}>
              <i className={`fa fa-retweet`}> {post.retweet}</i>
            </div>
            <div className={`col wd-gray wd-font-15`}>
              <i className={`fa fa-heart`}> {post.like}</i>
            </div>
            <div className={`col wd-gray wd-font-15`}>
              <i className={`fa fa-upload`}></i>
            </div>
          </div>
        </div>
      </div>
  );
}

export default PostItem;

